import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/button/back";

const PrestasiForAll = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrestasi = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/prestasi/${id}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Gagal mengambil data prestasi:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrestasi();
  }, [id]);

  const isImageLink = (url) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
  };

  const convertGDriveLinkToPreview = (url) => {
    if (url.includes("drive.google.com/file/d/")) {
      const fileId = url.split("/d/")[1]?.split("/")[0];
      return `https://drive.google.com/uc?export=view&id=${fileId}`;
    }
    return url;
  };

  if (loading) {
    return <p className="text-center mt-10 text-gray-500">Memuat...</p>;
  }

  if (!data) {
    return (
      <p className="text-center mt-10 text-red-500">Data tidak ditemukan.</p>
    );
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="pt-5 pb-5 pl-5">
        <Link to="/prestasi">
          <Back />
        </Link>
      </div>
      <h2 className="text-2xl font-bold mb-6 text-center">{data.judul}</h2>

      {/* Gambar dari server */}
      {data.gambar?.filename && (
        <div className="mb-6">
          <img
            src={`${process.env.REACT_APP_API_URL}api/prestasi/gambar/${data.gambar.filename}`}
            alt={data.judul}
            className="w-full max-h-[400px] object-contain rounded"
          />
        </div>
      )}

      {/* Gambar dari link (jika ada dan tidak ada file server) */}
      {!data.gambar?.filename && data.link && (
        <div className="mb-6">
          {isImageLink(data.link) || data.link.includes("drive.google.com") ? (
            <img
              src={convertGDriveLinkToPreview(data.link)}
              alt="Gambar dari link"
              className="w-full max-h-[400px] object-contain border rounded"
            />
          ) : (
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              {data.link}
            </a>
          )}
        </div>
      )}

      {/* Deskripsi */}
      <div>
        <h3 className="font-semibold mb-2">Deskripsi:</h3>
        <p className="text-gray-700 whitespace-pre-line">{data.deskripsi}</p>
      </div>
      <div className="pt-5 pb-5 pl-5">
        <Link to="/prestasi">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default PrestasiForAll;
